import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icon-loading.gif")